<template>
<div class="notification" :class="classes" v-show="!hide">
  <button v-show="canClose" class="delete" @click="onClose" aria-label="Remove notification" :aria-hidden="canClose"/>
  <VueShowdown :markdown="message" :options="{openLinksInNewWindow: true}" tag="span" class="msg"></VueShowdown>
  <span v-if="when" class="when">
    <timeago :datetime="when" :auto-update="60"/>
  </span>
</div>
</template>

<script>
import md5 from 'md5'
import Vue from 'vue'
import VueTimeago from '@gurupras/vue-timeago'
import TimedStorage from '@/js/timed-storage.js'

Vue.use(VueTimeago, {
  locale: 'en'
})

export default {
  name: 'status-bar',
  components: {
    VueShowdown: () => import(/* webpackChunkName: "vue-showdown" */ 'vue-showdown/src/components/vue-showdown')
  },
  props: {
    message: {
      type: String,
      required: true
    },
    classes: {
      type: [String, Array, Object],
      default: 'primary'
    },
    when: {
      type: Number,
      default: 0
    },
    canClose: {
      type: Boolean,
      default: true
    },
    storage: {
      type: [Object, Storage],
      default () {
        return localStorage
      }
    },
    persistDuration: {
      type: String,
      default: ''
    }
  },
  computed: {
    hash () {
      const { message } = this
      return md5(message)
    },
    storageKey () {
      const { hash } = this
      return `status:${hash}`
    }
  },
  data () {
    return {
      hide: false
    }
  },
  methods: {
    onClose () {
      const { persistDuration, timedStorage } = this
      if (persistDuration) {
        const { storage, storageKey } = this
        if (!storage) {
          return
        }
        timedStorage.setItem(storageKey, 'closed', persistDuration)
      }
      this.hide = true
      this.$emit('close')
    }
  },
  async beforeMount () {
    const { storage, storageKey, persistDuration } = this
    if (!storage) {
      return
    }
    const timedStorage = this.timedStorage = new TimedStorage(storage)
    // If the user closed this in the past, then the gap between now and expiry cannot be greater than persistDuration
    const expiry = timedStorage.getExpiry(storageKey)
    let quantity
    let units
    try {
      [quantity, units] = timedStorage.splitDuration(persistDuration)
    } catch (e) {
      quantity = 0
      units = 's'
    }
    const { default: moment } = await import('moment')
    const now = moment()
    const expiryIfClosedNow = now.add(quantity, units).utc().valueOf()
    if (expiry > expiryIfClosedNow) {
      // persistDuration has changed
      storage.removeItem(storageKey)
    }
    const result = timedStorage.getItem(storageKey)
    if (result === 'closed') {
      this.hide = true
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  padding-top: 7px;
  padding-bottom: 7px;

  .msg {
    ::v-deep p {
      display: inline-block;
    }
    ::v-deep a {
      cursor: pointer;
    }
  }
  .when {
    margin-left: 0.3em;
  }
}
</style>
